import React from "react";
import styles from "./styles";
import ImageAbove from "../PostsSlice/ImageAbove";
import Warning from "../Warning";
import ImageLeft from "../PostsSlice/ImageLeft";
import ImageRight from "../PostsSlice/ImageRight";
import ImageBelow from "../PostsSlice/ImageBelow";

export const PostsList = ({ blocks }) => {
  const renderPostType = (block) => {
    if (block.primary.image_position === "Left") {
      return <ImageLeft block={block} />;
    } else if (block.primary.image_position === "Right") {
      return <ImageRight block={block} />;
    } else if (block.primary.image_position === "Above") {
      return <ImageAbove block={block} />;
    } else {
      return <ImageBelow block={block} />;
    }
  };
  return (
    <>
      <div className="posts-wrapper">
        {blocks?.length ? (
          blocks.map((block, index) => {
            const nextBlockHasTitle =
              blocks[index + 1]?.primary?.content_title?.[0]?.text?.length > 0;

            return (
              <React.Fragment key={block.id}>
                {block.primary.content_title && (
                  <span id={`${block.id}`}></span>
                )}
                {renderPostType(block)}
                {index < blocks.length - 1 && nextBlockHasTitle && (
                  <div className="divider" />
                )}
              </React.Fragment>
            );
          })
        ) : (
          <Warning />
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default PostsList;
